import { NgModule } from '@angular/core';

// import { EnvironmentItemComponent } from '@app/authorized/projectWizard/environment-item/environment-item.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DbmAdditionalOptionsModule } from '@app/shared/components/dbm-components/dbm-additional-options/dbm-additional-options.module';
import { DirectivesModule } from '@app/shared/directives/directives.module';
import { SettingComponent } from './settings-ang7/settings';
import {SchemaItemModule} from './schema-item/schema-item.module'
// import { SchemaItemComponent } from '@app/authorized/projectWizard/schema-item/schema-item.component';
//import { SchemaConnectorComponent } from '@app/authorized/projectWizard/schema-connector/schema-connector.component';
//import { EnvironmentComponent } from '../project/pipeline/environments-ang7/environment/environment';
// import { EnvironmentTypeComponent } from '../project/pipeline/environments-ang7/environmentType';
import { EnvironmentModule } from '../project/pipeline/environments-ang7/environment/environment.module';
import { EnvironmentTypeModule } from '../project/pipeline/environments-ang7/environmentType.module';
//import { MyFilterPipe } from './myfilter.pipe';
// import { RotateSchemasRepositoryComponent } from '@app/authorized/projectWizard/assignSchemas-ang7/environmentTypeRotator/rotatorItem/rotate-schemas-repository/rotate-schemas-repository.component';
// import {en}
// import { EnvTypeRotateItemComponent } from './assignSchemas-ang7/environmentTypeRotator/rotatorItem/rotatorItem'; 
// import { EnvironmentsRotatorComponent } from './assignSchemas-ang7/environmentTypeRotator/rotatorItem/environmentsRotator/environmentsRotator';
// import { AssignSchemasComponent } from './assignSchemas-ang7/assignSchemas';
// import { EnvTypeRotateComponent } from './assignSchemas-ang7/environmentTypeRotator/environmentTypeRotator';
import { EnvironmentTypes } from './environmentTypes-ang7/environmentTypes';
import { ProjectWizardComponent } from './projectWizard-ang7';
import {AssignSchemasModule} from './assignSchemas-ang7/assignSchemas.module'
import { SharedModule } from '@app/shared';
import {SchemaConnectorModule} from './schema-connector/schema-connector.module'
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [SharedModule,EnvironmentModule,SchemaItemModule,AssignSchemasModule,SchemaConnectorModule, DragDropModule,EnvironmentTypeModule , DirectivesModule , DbmAdditionalOptionsModule , FormsModule],
    declarations: [
        // EnvironmentItemComponent,
        //SchemaConnectorComponent,
        // EnvironmentsRotatorComponent,
        // EnvTypeRotateItemComponent,
        // EnvTypeRotateComponent,
        // AssignSchemasComponent,
        EnvironmentTypes,
        ProjectWizardComponent,
       // SchemaItemComponent,
        SettingComponent,
        // RotateSchemasRepositoryComponent
    ],
    entryComponents: [
        // EnvironmentItemComponent,
        ProjectWizardComponent,
        // EnvTypeRotateItemComponent,
        // EnvironmentsRotatorComponent,
        // EnvTypeRotateComponent,
        // AssignSchemasComponent,
        // SchemaConnectorComponent,
        EnvironmentTypes,
       // SchemaItemComponent,
        SettingComponent,
        // RotateSchemasRepositoryComponent
    ],
    providers: [],
    exports: [
        // EnvironmentItemComponent,
        ProjectWizardComponent,
        // AssignSchemasComponent,
        // EnvTypeRotateItemComponent,
        // EnvironmentsRotatorComponent,
        // EnvTypeRotateComponent,
        // SchemaConnectorComponent,
        EnvironmentTypes,
       // SchemaItemComponent,
        SettingComponent,
        // RotateSchemasRepositoryComponent
    ],
})
export class ProjectWizardModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/projectWizard/project-wizard.module.ts